import { Injectable } from '@angular/core';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { BehaviorSubject } from 'rxjs';
import { AppoinmentService } from './care-central/appoinment.service';
import { FeatureModel } from '@drl/core/auth/models/feature.model';
import { menuItem } from './pages-menu';
import { patientMenuItem } from './patient-pages-menu';
import { IpsTranslateService } from '@drl/core/localization/ips-translate.service';
import { Patient } from '@drl/shared/models';
import { UserStatus } from '@drl/core/enums';

@Injectable({
  providedIn: 'root',
})
export class MenuService {

  menuItemsSubject = new BehaviorSubject<NbMenuItem[]>([]);
  menuItems$ = this.menuItemsSubject.asObservable();
  patientId: number;


  constructor(
    protected readonly translateSvc: IpsTranslateService,
  ) {

  }

  setPatientMenu(patient: Patient) {
    if (patient.id !== this.patientId) {
      const isPatActive = patient.status?.id >= UserStatus.ACTIVE;
      let patientMenuItems = patientMenuItem(this.translateSvc.translate);
      patientMenuItems = patientMenuItems.map(item => {
        const chatLabel=this.translateSvc.translate.instant('chatMenuLabel')
        if (item.title == chatLabel) {
          item.hidden = isPatActive ? false : true;
        }
        return item;
      });
      this.menuItemsSubject.next(patientMenuItems);
      this.patientId = patient.id;
    }

  }


}
